export default "__VITE_ASSET__D4K70agm__"